
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
components: {
XSwitch
},
data() {
return {
switchModel:'1'
}
},
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-switch.vue